import { render, staticRenderFns } from "./PopupScopeGDLS.vue?vue&type=template&id=324bbf66&scoped=true&lang=pug&"
import script from "./PopupScopeGDLS.vue?vue&type=script&lang=ts&"
export * from "./PopupScopeGDLS.vue?vue&type=script&lang=ts&"
import style0 from "./PopupScopeGDLS.vue?vue&type=style&index=0&id=324bbf66&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324bbf66",
  null
  
)

export default component.exports